/**
 * undercover® — gedeelde winkelwagen-helper.
 *
 *   await window.ucCart.add([{ id: 123, quantity: 1 }, { id: 456, quantity: 1, properties: { … } }], { source: 'reels' });
 *
 * Voegt één of meer regels toe via /cart/add.js, laat Horizon de cart drawer bijwerken en
 * openen (CartLinesUpdateEvent), laat het winkelwagen-icoon "bumpen" en toont bij een fout
 * een toast. Geeft de bijgewerkte cart (JSON) terug of gooit een Error met een leesbare melding.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

const toast = (message, tone = 'error') => {
  let host = document.querySelector('.uc-toast-host');
  if (!host) {
    host = document.createElement('div');
    host.className = 'uc-toast-host';
    host.setAttribute('role', 'status');
    host.setAttribute('aria-live', 'polite');
    document.body.append(host);
  }
  const el = document.createElement('p');
  el.className = `uc-toast uc-toast--${tone}`;
  el.textContent = message;
  host.append(el);
  setTimeout(() => el.classList.add('is-leaving'), 3600);
  setTimeout(() => el.remove(), 4000);
};

const sectionIds = () =>
  [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);

const bumpCartIcon = () => {
  document.querySelectorAll('.header-actions__cart-icon, cart-icon, .cart-bubble').forEach((el) => {
    el.classList.remove('uc-bump');
    void el.offsetWidth;
    el.classList.add('uc-bump');
  });
};

async function add(items, { source = 'uc', origin = document.body } = {}) {
  const lines = items.map((item) => ({ ...item, id: Number(item.id), quantity: Number(item.quantity || 1) }));
  const deferred = CartLinesUpdateEvent.createPromise();

  origin.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: lines.map((line) => ({ merchandiseId: String(line.id), quantity: line.quantity })),
      promise: deferred.promise,
    })
  );

  try {
    const ids = sectionIds();
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines, ...(ids.length ? { sections: ids.join(',') } : {}) }),
    });
    const data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'toevoegen mislukt');
    }

    const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: { Accept: 'application/json' },
    }).then((r) => r.json());

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source, itemCount: lines.reduce((n, l) => n + l.quantity, 0), sections: data.sections, didError: false },
    });
    bumpCartIcon();
    return cart;
  } catch (error) {
    // AbortError: Horizon-listeners negeren dit stil en laten de teller ongemoeid
    deferred.reject(new DOMException(error.message || 'add failed', 'AbortError'));
    toast(error.message || 'toevoegen mislukt');
    throw error;
  }
}

window.ucCart = { add, toast };
document.dispatchEvent(new CustomEvent('uc:cart-ready'));
